// extracted by mini-css-extract-plugin
export default {"root":"SectionLoader_root__XEHkB","loader":"SectionLoader_loader__sWeCg"};